import React, { useState, useEffect } from 'react';
import "./BybFooter.css"
import byblogo from "../../../assets/selfaudit/images/byblogo.svg"
// import BybPrivacyPolicy from '../BybPrivacyPolicy/BybPrivacyPolicy'
import { Link } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal';
import { ABOUT_BYB_DESCRIPTION } from '../../Common/Seo/aboutBybContent';

function BybFooter() {
   // StartUp Modal
   const [modalShow, setModalShow] = React.useState(false);


  function ContactUs(props) {
    return (
      <Modal
        {...props}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contact_us_modal "
      >
         <Modal.Header closeButton className="border-0">
        {/* <Modal.Title id="contained-modal-title-vcenter">
        Startups
        </Modal.Title> */}
      </Modal.Header>
        <Modal.Body>
        <div className="contact-container">
      <h3>Contact Us</h3>
      <div className="contact-cards">
        <div className="contact-card">
          <h2>Chat to Sales</h2>
          <p>Speak to our friendly team</p>
          <a href="mailto:info@brewyourbran">info@brewyourbrand.in</a>
        </div>
        <div className="contact-card">
          <h2>Call Us</h2>
          <p>Mon - Sat from 10am to 7pm</p>
          <p className="phone-number">+91 8150 00 22 55</p>
        </div>
      </div>
    </div>
        </Modal.Body>
      
      </Modal>
    );
  }
  useEffect(() => {
    const scriptSrc = 'https://embed.typeform.com/next/embed.js';

    const loadTypeformScript = () => {
      if (document.querySelector(`script[src="${scriptSrc}"]`)) {
        return;
      }

      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    };

    const idleCallbackId = window.requestIdleCallback
      ? window.requestIdleCallback(loadTypeformScript, { timeout: 3000 })
      : window.setTimeout(loadTypeformScript, 3000);

    return () => {
      if (window.cancelIdleCallback && typeof idleCallbackId === 'number') {
        window.cancelIdleCallback(idleCallbackId);
      } else {
        window.clearTimeout(idleCallbackId);
      }
    };
  }, []);
  
  return (
    <>
    <section className='byb-footer'>
    <div className='container'>
       <div className='byb-footer-top'>

     
        <div className="byb-footer-logo-section">
            <div className="byb-footer-logo" >
            <img src={byblogo} alt="Brew Your Brand logo" />
            <p className="byb-footer-about">{ABOUT_BYB_DESCRIPTION}</p>
            </div>
          
          <p className="byb-footer-contact"> <span>More ways to buy:</span>
            <a href="mailto:info@brewyourbrand.in"> info@brewyourbrand.in or</a> <a href="tel:+918150002255">+91-8150 00 22 55</a></p>
        </div>

    <div class='byb-footer-top-content'>
                <div class="byb-footer-menu">
                    <ul>
                      <li><a href="https://brewyourbrand.in/e-magazine/">eMagazine</a></li>
                     
                      <li><a href='https://brewyourbrand.in' class='pe-auto'>Complete Brand Series</a></li>
                      <li><a href='https://course.brewyourbrand.in/services/learning' class='pe-auto'>Learning</a></li>
                      <li><a href='https://chat.whatsapp.com/CTkM6q19Ltc3Btg5t6VcLZ' class='pe-auto'>Join Community</a></li>
                      <li><a href='https://brewyourbrand.in/quick-brand-assessment/' class='pe-auto'>Get a Quick Brand Assessment  </a></li>
                   
                    </ul>
                </div>
            </div>
        <div className='byb-footer-top-content'>
                <div className="byb-footer-menu">
                <ul>
                  <li><a href="https://brewyourbrand.in/brandselfauditkit">Overview</a></li>
                  <li><a href="https://brewyourbrand.in/brandselfauditkit#choose_brew">Pricing</a></li>
                  <li><button type="button" className='byb-footer-link-trigger pe-auto' onClick={() => setModalShow(true)}>Contact Us</button></li>
                </ul>
            </div>
        </div>
      </div>
 
      <div className="byb-footer-line"></div>

      <div className="byb-footer-bottom">
        <p>Copyright &copy; {new Date().getFullYear()} Brew Your Brand. All Rights Reserved.</p>
        {/* <div className="byb-footer-links"> */}
          {/* <a href="/privacy-policy">Privacy</a>

          <a href="/terms-and-conditions">Terms & Conditions</a>
          <a href="/shipping-delivery">Shipping & Delivery</a>
          <a href="/shipping-delivery">Cancellation & Refund Policy</a>
          <a href="#">Site Map</a>
          <a href="#">Site Map</a> */}

          <div className="byb-footer-links">
            <Link to="https://brewyourbrand.in/privacy-policy">Privacy</Link>
            <Link to="https://brewyourbrand.in/terms-and-conditions">Terms & Conditions</Link>
            <Link to="https://brewyourbrand.in/shipping-delivery">Shipping & Delivery</Link>
            <Link to="https://brewyourbrand.in/cancellation-refund">Cancellation & Refund Policy</Link>
        </div>

        {/* </div> */}
      </div>
      </div>
    </section>
    
    <ContactUs
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    
    </>
  )
}

export default BybFooter
